var exports = {
  "oR": "Toast.module__toast___YWw4X2",
  "Gv": "Toast.module__toastMobile___YWw4X2",
  "qS": "Toast.module__toastDesktop___YWw4X2",
  "Kk": "Toast.module__icon___YWw4X2",
  "PO": "Toast.module__iconSuccess___YWw4X2",
  "m5": "Toast.module__iconError___YWw4X2",
  "oq": "Toast.module__iconMobile___YWw4X2",
  "gB": "Toast.module__iconDesktop___YWw4X2",
  "Qq": "Toast.module__text___YWw4X2",
  "wV": "Toast.module__textMobile___YWw4X2",
  "eL": "Toast.module__textDesktop___YWw4X2",
};

module.exports = exports;
